import React from 'react';
import { Award } from 'lucide-react';
import { aboutData } from '../data/mockData';
import { AnimateOnScroll } from '../hooks/useScrollAnimation';

const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-20 md:py-32 bg-[#08080a] border-y border-white/5 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <AnimateOnScroll className="order-2 lg:order-1">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                <span className="text-xs font-bold text-primary uppercase tracking-widest">
                  {aboutData.badge}
                </span>
              </div>

              <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-white font-bold uppercase tracking-tight mb-6 leading-[1.1] italic">
                {aboutData.headingPart1}
                <br className="hidden lg:block" />{' '}
                <span className="gold-gradient">{aboutData.headingHighlight}</span>
                <br className="hidden lg:block" />{' '}
                {aboutData.headingPart2}
              </h2>

              <p className="text-zinc-400 text-base md:text-lg mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0">
                {aboutData.description}
              </p>

              <div className="flex justify-center lg:justify-start gap-12">
                {aboutData.stats.map((stat) => (
                  <div key={stat.label} className="text-center lg:text-left">
                    <h4 className="font-heading text-4xl text-white font-bold mb-1 italic">
                      {stat.value}
                    </h4>
                    <p className="text-primary text-xs sm:text-sm uppercase tracking-wider font-bold">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </AnimateOnScroll>

          {/* Image */}
          <AnimateOnScroll className="order-1 lg:order-2 w-full">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-square sm:aspect-video lg:aspect-square group">
              <div className="absolute inset-0 bg-primary/10 z-10 mix-blend-overlay group-hover:opacity-0 transition-opacity duration-700" />
              <img
                src={aboutData.image}
                alt={aboutData.imageAlt}
                className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
              />
              {/* Award Badge */}
              <div className="absolute bottom-4 sm:bottom-6 right-4 sm:right-6 z-20 bg-black/80 backdrop-blur-md border border-white/10 p-4 rounded-2xl shadow-xl">
                <Award className="text-primary w-8 h-8 mb-2" />
                <p className="font-heading font-bold text-white text-sm italic">
                  Award Winning
                </p>
                <p className="text-zinc-400 text-xs">Stylists</p>
              </div>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
